import { useNavigate, useParams } from "react-router-dom";

import Grid from "@Components/Grid";
import Paper from "@Components/Paper";
import BackButton from "@Components/BackButton";
import { useGetTitleIssue } from "@Hooks/useTitleIssues";

import Overview from "./Overview";
import styles from "./TitleIssue.module.scss";
import LoadingFullScreen from "@Components/Loading/LoadingFullScreen";
import PreviewDocument from "./PreviewDocuments/PreviewDocument";
import DmvInfo from "./DmvInfo";
import Button from "@Components/Button";

export default function TitleIssue() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { titleIssue } = useGetTitleIssue(id as string);

  const deal = titleIssue?.data.deal;

  const handleOpenLoan = () => {
    navigate(`/loans/${deal?._id}`);
  };

  if (!id) return <>Error</>;
  if (!titleIssue) return <LoadingFullScreen />;
  return (
    <Grid className={styles.root} xs={12} container spacing={1}>
      <Grid xs={12}>
        <BackButton />
      </Grid>
      <Grid xs={9}>
        <h2 className={styles.title}>Title Issue</h2>
      </Grid>
      {deal && (
        <Grid xs={3}>
          <Button variant="blue" onClick={handleOpenLoan}>
            Open Loan Information
          </Button>
        </Grid>
      )}
      <Grid xs={6}>
        <Paper
          title="Overview"
          style={{ height: "100%", boxSizing: "border-box" }}
        >
          <Overview titleIssue={titleIssue} />
        </Paper>
      </Grid>

      <Grid xs={6}>
        <DmvInfo titleIssue={titleIssue} />
      </Grid>
      <Grid xs={12}>
        <Paper
          title="Documents"
          style={{ height: "100%", boxSizing: "border-box" }}
        >
          <Grid xs={12} container>
            <Grid xs={4}>
              <PreviewDocument
                title="Copy of the original title"
                description="Signed by dealer and buyer if done in person"
                data={titleIssue?.data?.info?.oldTitleRegistrationInfo}
              />
            </Grid>
            <Grid xs={4}>
              <PreviewDocument
                title="Copy of the completed title application"
                description="Including lien-holder for the appropriate state"
                data={titleIssue?.data?.info?.titleRegistrationInfo}
              />
            </Grid>
            <Grid xs={4}>
              <PreviewDocument
                title="Paid receipt"
                description="Paid receipt from appropriate state DMV"
                data={titleIssue?.data?.info?.receiptInfo}
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
}
